import React, { useEffect, useState } from 'react';
import { BookOpen, Volume2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { apiGet } from '../utils/api';

const LEVEL_COLORS = {
  A1: 'bg-green-100 text-green-700',
  A2: 'bg-emerald-100 text-emerald-700',
  B1: 'bg-blue-100 text-blue-700',
  B2: 'bg-indigo-100 text-indigo-700'
};

const WordOfDay = () => {
  const [word, setWord] = useState(null);
  const selectedCountry = localStorage.getItem('selectedCountry') || 'italy';

  useEffect(() => {
    apiGet(`/api/word-of-the-day?country=${selectedCountry}`)
      .then(d => d && setWord(d))
      .catch(() => {});
  }, [selectedCountry]);

  if (!word) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="bg-white border border-border rounded-2xl p-6 sm:p-8 hover:border-primary/30 transition-all shadow-sm"
      data-testid="word-of-day-widget"
    >
      <div className="flex items-center gap-2 mb-4">
        <BookOpen size={20} className="text-accent" />
        <span className="text-sm font-semibold text-accent uppercase tracking-wider">{word.language || 'Word'} of the Day</span>
        <span className={`text-xs px-2 py-0.5 rounded-full font-medium ml-auto ${LEVEL_COLORS[word.level] || 'bg-gray-100 text-gray-600'}`}>
          {word.level}
        </span>
      </div>

      <h3 className="text-3xl sm:text-4xl font-bold text-primary mb-1" data-testid="word-italian">
        {word.word}
      </h3>
      <div className="flex items-center gap-2 mb-3">
        <Volume2 size={14} className="text-muted-foreground" />
        <span className="text-sm text-muted-foreground italic">{word.pronunciation}</span>
      </div>
      <p className="text-lg text-secondary font-medium mb-4" data-testid="word-english">{word.english}</p>

      <div className="bg-muted/50 rounded-xl p-4 space-y-1">
        <p className="text-sm text-primary font-medium italic">"{word.example_local}"</p>
        <p className="text-xs text-muted-foreground">"{word.example_en}"</p>
      </div>

      <div className="mt-3 flex items-center gap-2">
        <span className="text-xs bg-primary/10 text-primary px-2 py-1 rounded-full">{word.category}</span>
      </div>
    </motion.div>
  );
};

export default WordOfDay;
